module.exports = __webpack_public_path__ + "files/3b2f42c0ae4692b6bd082a7b9f9efd87.svg";